import React, {Component} from 'react';
import {Grid, Button, FormGroup, FormControl, Row, Col} from 'react-bootstrap';


import {
    FacebookShareButton,
    GooglePlusShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    TelegramShareButton,
    WhatsappShareButton,
    PinterestShareButton,
    VKShareButton,
    OKShareButton,
    RedditShareButton,
    TumblrShareButton,
    LivejournalShareButton,
    EmailShareButton,
} from 'react-share';


import {
    FacebookIcon,
    TwitterIcon,
    TelegramIcon,
    WhatsappIcon,
    GooglePlusIcon,
    LinkedinIcon,
    PinterestIcon,
    VKIcon,
    OKIcon,
    RedditIcon,
    TumblrIcon,
    LivejournalIcon,
    MailruIcon,
    EmailIcon,
} from 'react-share';


import './BookDetails.css';


export default class BookDetails extends Component {

    createMarkup() {

        return {__html: this.props.data.description};

    }


    getSrc() {


        let mydata = {advisor: '', author: '', editor: '', src: 'assets/book.png'};

        for (let j = 0; j < this.props.data.MaterialProperties.length; j++) {
            if (this.props.data.MaterialProperties[j].pattern === 'COVER_PATH') {
                mydata.src = this.props.data.MaterialProperties[j].value;
            }

            if (this.props.data.MaterialProperties[j].pattern === 'NUMBER_OF_PAGE') {
                mydata.NUMBER_OF_PAGE = this.props.data.MaterialProperties[j].value;
            }

            if (this.props.data.MaterialProperties[j].pattern === 'PUBLISH_HOUSE') {
                mydata.PUBLISH_HOUSE = this.props.data.MaterialProperties[j].value;
            }

            if (this.props.data.MaterialProperties[j].pattern === 'PRESS_DATE') {
                mydata.PRESS_DATE = this.props.data.MaterialProperties[j].value;
            }

            if (this.props.data.MaterialProperties[j].pattern === 'ISBN') {
                mydata.ISBN = this.props.data.MaterialProperties[j].value;
            }

            if (this.props.data.MaterialProperties[j].pattern === 'VOLUME') {
                mydata.VOLUME = this.props.data.MaterialProperties[j].value;
            }

            if (this.props.data.MaterialProperties[j].pattern === 'NUMBER') {
                mydata.NUMBER = this.props.data.MaterialProperties[j].value;
            }

            if (this.props.data.MaterialProperties[j].pattern === 'PAGE_INTERVAL') {
                mydata.PAGE_INTERVAL = this.props.data.MaterialProperties[j].value;
            }

            if (this.props.data.MaterialProperties[j].pattern === 'CONFERENCE') {
                mydata.CONFERENCE = this.props.data.MaterialProperties[j].value;
            }


            if (this.props.data.MaterialProperties[j].pattern === 'AUTHOR') {
                if (mydata.author != '') {
                    mydata.author += ' , '
                }
                mydata.author += this.props.data.MaterialProperties[j].value;
            }

            if (this.props.data.MaterialProperties[j].pattern === 'EDITOR') {
                if (mydata.editor != '') {
                    mydata.editor += ' , '
                }
                mydata.editor += this.props.data.MaterialProperties[j].value;
            }

            if (this.props.data.MaterialProperties[j].pattern === 'ADVISOR') {
                if (mydata.advisor != '') {
                    mydata.advisor += ' , '
                }
                mydata.advisor += this.props.data.MaterialProperties[j].value;
            }

        }

        return mydata;
    }


    getEditor(editor, plural, singular) {

        if (editor === undefined || editor === null || editor === "") {
            return (
                <div>

                </div>
            )
        }

        if (editor.includes(",")) {

            return (
                <h5>{plural} : {editor}</h5>
            )


        } else {
            return (
                <h5>{singular} : {editor}</h5>
            )

        }


    }


    getProperty(mydata, porpertyName, propertyDesc) {


        if (mydata[porpertyName] === undefined || mydata[porpertyName] === "") {
            return (
                <div>


                </div>

            )

        }
        return (
            <div>
                <h5>{propertyDesc + " : " + mydata[porpertyName]} </h5>
            </div>

        )


    }


    render() {


        if (this.props.flagg === false) {

            return (
                <div>

                </div>

            )

        }


        let mydata = this.getSrc();

        const shareUrl = window.location.href;
        const title = this.props.data.name;

        console.log(window.location.href);

        return (
            <Grid>
                <Col lg={4} md={4}>

                    <div style={{padding: '10px'}}>

                        <a target="_blank" href={"https://ets.anadolu.edu.tr/storage/nfs/" + this.props.data.file_path}>
                            <h6>

                            </h6>
                            <img width={342} onError={(e) => {
                                e.target.src = "assets/book.png"
                            }}
                                 src={mydata.src}/>
                            <br/>
                        </a>
                    </div>

                </Col>


                <Col lg={8} md={8}>
                    <h2>{this.props.data.name}</h2>
                    <br/>
                    <h5>Türü : {this.props.data.material_type}</h5>
                    {this.getEditor(mydata.author, 'Yazarlar', 'Yazar')}
                    <br/>
                    {this.getEditor(mydata.editor, 'Editörler', 'Editör')}
                    {this.getEditor(mydata.advisor, 'Danışmanlar', 'Danışman')}
                    {this.getProperty(mydata, 'PUBLISH_HOUSE', "Yayınevi")}
                    {this.getProperty(mydata, 'CONFERENCE', "Konferans/Dergi")}
                    {this.getProperty(mydata, 'Volume', "Cilt")}
                    {this.getProperty(mydata, 'NUMBER', "Sayı")}
                    {this.getProperty(mydata, "PAGE_INTERVAL", "Sayfa")}
                    {this.getProperty(mydata, "NUMBER_OF_PAGE", "Sayfa Sayısı")}
                    {this.getProperty(mydata, "PRESS_DATE", "Yayın Yılı")}

                    <br/> <br/>
                    <div dangerouslySetInnerHTML={this.createMarkup()}/>
                    <br/> <br/>

                    <Row>
                        <Col md={1} mdOffset={0}>
                            <div className="Demo__some-network">
                                <FacebookShareButton
                                    url={shareUrl}
                                    quote={title}
                                    className="Demo__some-network__share-button">
                                    <FacebookIcon
                                        size={64}
                                        round/>
                                </FacebookShareButton>

                            </div>
                        </Col>

                        <Col md={1} mdOffset={1}>


                            <div className="Demo__some-network">
                                <TwitterShareButton
                                    url={shareUrl}
                                    title={title}
                                    className="Demo__some-network__share-button">
                                    <TwitterIcon
                                        size={64}
                                        round/>
                                </TwitterShareButton>

                            </div>


                        </Col>


                        <Col md={1} mdOffset={1}>


                            <div className="Demo__some-network">
                                <WhatsappShareButton
                                    url={shareUrl}
                                    title={title}
                                    separator=":: "
                                    className="Demo__some-network__share-button">
                                    <WhatsappIcon size={64} round/>
                                </WhatsappShareButton>

                            </div>


                        </Col>


                    </Row>

                </Col>


            </Grid>

        )
    }

}




// WEBPACK FOOTER //
// ./src/components/BookDetails.js